import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, NgForOf } from "@angular/common";
import { FADEIN_OUT_ANIMATION } from '../../../shared/constants/animations';
import { RouterLink } from "@angular/router";
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  // animations: FADEIN_OUT_ANIMATION,
  selector: 'app-main-how-it-works',
  imports: [CommonModule, RouterLink],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title)
  weeklyGroceries = [
    {
      title: 'Produce',
      img: '../../../assets/images/landing/how-it-works/produce-category.webp',
      url: 'produce'
    },
    {
      title: 'Meat & Seafood',
      img: '../../../assets/images/landing/how-it-works/meat-category.webp',
      url: 'meat-&-seafood'
    },
    {
      title: 'Dairy',
      img: '../../../assets/images/landing/how-it-works/dairy-category.webp',
      url: 'dairy'
    },
    {
      title: 'Pantry',
      img: '../../../assets/images/landing/how-it-works/pantry-category.webp',
      url: 'pantry'
    },
    {
      title: 'Bakery',
      img: '../../../assets/images/landing/how-it-works/bakery-category.webp',
      url: 'bakery'
    },
    {
      title: 'Beverages',
      img: '../../../assets/images/landing/how-it-works/beverages-category.webp',
      url: 'beverages'
    },
  ]

  foodItem = [
    {
      title: 'Customizable Shares',
      img: '../../../assets/images/landing/how-it-works/customizable-boxes.webp',
      url: '',
      text: 'Remove any items you do not like or already have too much of.'
    },
    {
      title: 'Harvest Shares',
      img: '../../../assets/images/landing/how-it-works/harvest-boxes.webp',
      url: '',
      text: 'The farmers harvest. No customization but you save 10% on the items.'
    },
    {
      title: 'Supplemental Shares',
      img: '../../../assets/images/landing/how-it-works/supplemental-boxes.webp',
      url: '',
      text: 'Cheese, coffee, meat and more! Fully customizable.'
    },
  ]

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/how-it-works/main'
    const component = 'How it Works'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }
}
